/* Wrapper around react-plotly's Plot so we can set defaults */

import moment from "moment";
import { FC } from "react";

import { Plot, type PlotParams } from "@nens/plotly";

const ThreediPlot: FC<PlotParams> = ({ config = {}, layout = {}, ...props }) => {
  const defaultLayout: PlotParams["layout"] = {
    dragmode: false,
  };

  const defaultConfig: PlotParams["config"] = {
    displayModeBar: false,
    showAxisDragHandles: false,
  };

  return (
    <Plot
      config={{ ...defaultConfig, ...config }}
      layout={{ ...defaultLayout, ...layout }}
      {...props}
      data={props.data.map((data) => ({ name: "", ...data }))}
    />
  );
};

export const createTimeHoverProps = (x: string[]) => ({
  x,
  hovertemplate: `%{text}, %{y:.2f}`,
  text: x.map((time, index) => {
    if (index === 0) return "Start";
    const milliseconds = moment(time).diff(x[0], "milliseconds");
    const longerThenDay = milliseconds > 86400000;
    const formattedTimePassed = moment
      .utc(milliseconds)
      .format(longerThenDay ? "D HH:mm" : "HH:mm");
    return (longerThenDay ? "Day " : "") + formattedTimePassed;
  }),
});

export default ThreediPlot;
